import { useState, useEffect } from "react";

import { ReactTyped } from "react-typed";

import { useRecord } from "@latticexyz/stash/react";
import mudConfig from "contracts/mud.config";
import { stash } from "../../../mud/stash";
import { useSessionPlayer } from "../../../SessionPlayerContext";

import MainButton from "../../../components/MainButton";
import ButtonStyleText from "../../../components/ButtonStyleText";

import { getGuideText, textConst } from "../../../text";

import imgMachine from "../../../assets/images/guide-machine.gif";

export const SecretGuide = ({ onFollow = () => {}, showState=false}) => {
  const { address: userAddress } = useSessionPlayer();

  //const [secretState, setSecretState] = useState(0);
  //const [showState, setShowState] = useState( false );  

  const player = (userAddress) ? useRecord({
    stash, 
    table: mudConfig.tables.Player, 
    key: { counterValue: userAddress } 
  }) : false;

  const faction = (player) ? useRecord({
    stash, 
    table: mudConfig.tables.Fraction, 
    key: { counterValue: player.fraction } 
  })?.fractionName : false;

  const [statement, setStatement] = useState(getGuideText( faction, textConst.SECRET_ONE) );

  // useEffect( () => {    
  //   if( player.secret > 0 && player.secret !== secretState ){
  //     setSecretState( player.secret );
  //     setShowState( true );
  //     const TCONST = ( player.secret === 1 ) 
  //       ? textConst.SECRET_ONE
  //       : (player.secret === 2 )
  //         ? textConst.SECRET_TWO
  //         : (player.secret === 3 )
  //           ? textConst.SECRET_THREE
  //           : false;
  //     if( TCONST ){
  //       setStatement( getGuideText( faction, TCONST ) );
  //     }   
  //   }
  // }, [player] );

  if( player.secret === 0 ){
    return '';
  }

  return (showState) 
    ? <div className="secret-guide-image fango-guide">
        <ButtonStyleText text={'..God? Devil? Machine?'} className="fango-guide--name" />
        <MainButton 
          className="fango-guide--next"
          name="Follow it"
          onClick={()=>{            
            //setShowState( false );
            onFollow();
          }} 
        /> 
        <div className="fango-guide--box">
          <div className="fango-guide--avatar">
            <img src={imgMachine} />
          </div>  
          <div className="fango-guide--text">
              <div>
                <ReactTyped
                  strings={ [statement] }
                  typeSpeed={5}
                  showCursor={false}
                  onStart={()=>{}}
                  onComplete={()=>{
                    
                  }}
                />
              </div>
            </div>           
        </div>
      </div> 
    : '';
}